namespace JupitersChoice {
    export class UpdateReelLockStripsCmd {

        @inject('ComponentManager') _componentManager: Sapphire.ComponentManager;
        @inject('GameConfig') _config: Sapphire.GameConfig;
        @inject('GameServer') _gameServer: Sapphire.GameServer;
        @inject('ResponseHelper') _responseHelper: ResponseHelper;

        execute(): void {
            const response: any = this._gameServer.logicResponse;
            const grids = this._config.get('external', 'grids');
            const reelsetType = grids[response.grid].reels;
            const reels = this._componentManager.get('Reels');
            const lockedReels = this._responseHelper.getLockedReels(response.lockedWithPreviousReel);

            for (let i = 0; i < 2; i++) {
                reels.updateStrips([lockedReels[i]], reelsetType[response.rawReelIndices[lockedReels[i]]], true);
            }
        }
    }
}